"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multipleClassQuery = void 0;
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
exports.multipleClassQuery = (0, graphql_tag_1.default) `
  query ($market: String!, $language: String!, $filter: VehiclesFilterInput!) {
    classBodytypeVehicles(market: $market, language: $language, filter: $filter) {
      className
      classId
      bodytypes {
        bodytypeId
        bodytypeName
        models {
          modelSeries
          vehicles {
            baumuster
            bodytypeId
            bodytypeName
            changeYear
            classId
            ccsIds {
              vehicleConfiguration
            }
            className
            financeData {
              currency
              discountPrices {
                automatic {
                  discounts {
                    amount
                    netAmount
                    name
                    type
                  }
                  price
                  taxes {
                    amount
                    baseAmount
                    name
                    rate
                  }
                }
                manual {
                  discounts {
                    amount
                    netAmount
                    name
                    type
                  }
                  price
                  netPrice
                  taxes {
                    amount
                    baseAmount
                    name
                    rate
                  }
                }
              }
              prices {
                automatic {
                  netPrice
                  price
                  taxes {
                    amount
                    baseAmount
                    name
                    rate
                  }
                }
                manual {
                  netPrice
                  price
                  taxes {
                    amount
                    baseAmount
                    name
                    rate
                  }
                }
              }
            }
            images {
              cutouts {
                medium
              }
              stage
            }
            modelSeriesFacelift
            modelYear
            name
            nationalSalesType
            productGroup
            subBrands
            lifeCycle
            technicalData {
              engine {
                electricEngine {
                  powerInKw {
                    unit
                    value
                  }
                  wltpRange {
                    automatic {
                      total {
                        all {
                          individual
                        }
                        equivalentAll {
                          individual
                        }
                      }
                    }
                  }
                }
                combustionEngine {
                  powerInKw {
                    unit
                    value
                  }
                }
                engineConcept
                fuelType
              }
              emissions {
                automatic {
                  wltp {
                    weighted {
                      primaryEngine {
                        individual
                      }
                    }
                    total {
                      primaryEngine {
                        individual
                      }
                    }
                  }
                }
              }
              consumption {
                automatic {
                  wltp {
                    weighted {
                      primaryEngine {
                        individual
                      }
                    }
                    total {
                      primaryEngine {
                        individual
                      }
                    }
                  }
                }
              }
              transmission {
                defaultTransmission
              }
            }
            typeId
          }
        }
      }
    }
  }
`;
